module.exports = __webpack_public_path__ + "img/SE5020329081.b4044504.svg";